<script setup>
import {defineProps, onMounted, onUnmounted, nextTick, ref} from "vue";

defineProps({
  title: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
  bottomDescription: {
    type: String,
    default: ''
  },
  readingTime: {
    type: String,
    default: ''
  },

});

const scrolled = ref(false);
const containerRef = ref(null);

const checkScroll = () => {
  if (containerRef?.value) {
    const rect = containerRef?.value.getBoundingClientRect();
    scrolled.value = rect.top - 60 <= 0;
  }
}

onMounted(() => {
  window.addEventListener('scroll', checkScroll);
  nextTick(() => {
    checkScroll();
  })
})
onUnmounted(() => {
  window.removeEventListener('scroll', checkScroll);
});

</script>

<template>
  <div :class="['header-block', {'_scrolled': scrolled}]" ref="containerRef">
    <div class="header-block__inner">
      <div class="header-block__text">
        <span class="header-block__reading-time">{{ readingTime }}</span>
        <h1 class="header-block__title" v-html="title"></h1>
        <p class="header-block__description" v-html="description"></p>
      </div>
    </div>
    <img :src="require('@/assets/img/figure.svg')" alt="" class="header-block__figure">
    <img :src="require('@/assets/img/branch.png')" alt="" class="header-block__image">
    <div class="header-block__note">
      <span>{{ bottomDescription }}</span>
    </div>
  </div>
</template>
